import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // Importa Helmet
import { NotificationProvider } from './errnotification/context/NotificationContext';
import UserDashboard from './components/UserDashboard/UserDashboard';
import TemplatePage from './components/TemplatePage/TemplatePage';
import Home from './pages/Home';
import UserView from './pages/UserView';
import Asesoramiento from './pages/Asesoramiento';
import Merchandising from './pages/Merchandising';
import Cronometraje from './pages/Cronometraje';
import Inscripciones from './pages/Inscripciones';
import FeaturedEventsAdmin from './pages/FeaturedEventsAdmin';
import AllEvents from './pages/AllEvents';

const SvgGradients = () => (
  <svg width="0" height="0" style={{ position: "absolute" }}>
    <defs>
      <linearGradient
        id="blue-purple-gradient"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#bc00dd" />
        <stop offset="100%" stopColor="#6f00f7" />
      </linearGradient>
    </defs>
  </svg>
);

const App = () => {
  return (
    <NotificationProvider>
    <SvgGradients />
      {/* Metadatos globales para todas las páginas */}
      <Helmet>
        <title>InovateSport - Plataforma para Eventos Deportivos</title>
        <meta name="description" content="Sistema profesional para gestión de eventos deportivos, inscripciones, cronometraje y más." />
        <meta name="google" content="notranslate" />
        <link rel="icon" href="/favicon.ico" />

        {/* Open Graph / Facebook (WhatsApp usa esto) */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://innovatessport.com/" />
        <meta property="og:title" content="InovateSport - Plataforma para Eventos Deportivos" />
        <meta property="og:description" content="Sistema profesional para gestión de eventos deportivos, inscripciones, cronometraje y más." />
        <meta property="og:image" content="https://innovatessport.com/images/logox.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://innovatessport.com/" />
        <meta name="twitter:title" content="InovateSport - Plataforma para Eventos Deportivos" />
        <meta name="twitter:description" content="Sistema profesional para gestión de eventos deportivos, inscripciones, cronometraje y más." />
        <meta name="twitter:image" content="https://innovatessport.com/images/logox.png" />
      </Helmet>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin/dashboard/:slug" element={<UserDashboard />} />
        <Route path="/template/:slug" element={<TemplatePage />} />
        <Route path="/:slug" element={<UserView />} />
        <Route path="/Asesoramiento" element={<Asesoramiento/>} />
        <Route path="/Merchandising" element={<Merchandising/>} />
        <Route path="/Cronometraje" element={<Cronometraje/>} />
        <Route path="/Inscripciones" element={<Inscripciones/>} />
        <Route path="/Eventos" element={<AllEvents/>} />
        <Route path="/admin/featured-events" element={<FeaturedEventsAdmin />} />
        <Route path="*" element={
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0f172a', color: 'white' }}>
            <h1>404 - Página no encontrada</h1>
            <a href="/" style={{ color: '#00c6fb', marginTop: '20px', textDecoration: 'none' }}>Volver al inicio</a>
          </div>
        } />
      </Routes>
      </NotificationProvider>
  );
};

export default App;








